import styles from './SessionExpired.module.scss';

export const SessionExpired = () => {
  return (
    <div className={styles.root}>
      {/* <img src={F4C} alt="F4C Logo" /> */}
      <div className={styles.message}>
        Tu sesión ha expirado, serás redirigido para iniciar sesión
      </div>
    </div>
  );
};
